/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:33:22
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-21 15:59:48
 */

export default {
  path: 'merchant',
  component: () => import('@/pages/api/apiList'),
  meta: {
    title: 'API商户'
  },
  children: [{
      path: 'create',
      component: () => import('@/pages/api/CreateEdit'),
      meta: {
        title: '添加API商户'
      },
    },
    {
      path: ':api_id/create',
      component: () => import('@/pages/api/CreateEdit'),
      meta: {
        title: '查看API商户'
      },
    },
    {
      name: 'editApi',
      path: ':api_id/edit',
      component: () => import('@/pages/api/CreateEdit'),
      meta: {
        title: '编辑API商户'
      },
    },
  ]
}